import { useCallback } from "react";

export function useSessionStorage() {
  const getUserId = useCallback(() => sessionStorage.getItem("userId") || "", []);
  const setUserId = useCallback((id) => sessionStorage.setItem("userId", id), []);

  const getPdfUrl = useCallback(() => sessionStorage.getItem("pdfUrl") || "", []);
  const setPdfUrl = useCallback((url) => sessionStorage.setItem("pdfUrl", url), []);

  return { getUserId, setUserId, getPdfUrl, setPdfUrl };
}
